export const PLAN_LABELS = {
  none: "No active plan",
  explorer: "TWIN Explorer",
  growth: "TWIN Growth",
  professional: "TWIN Professional",
  enterprise: "TWIN Enterprise",
};
const RANK = { none: 0, explorer: 1, growth: 2, professional: 3, enterprise: 4 };
export const FEATURE_MIN_PLAN = {
  tenders: "explorer",
  tesm: "explorer",
  format_general: "explorer",
  bnbd: "growth",
  format_technical: "growth",
  pcei: "professional",
  pcab: "professional",
  tapi: "professional",
  format_commercial: "professional",
};
export const MODULE_MIN_PLAN = FEATURE_MIN_PLAN;

export const PRICING = {
  explorer: { monthly: 19, annualPerMonth: 15, annualTotal: 180 },
  growth: { monthly: 99, annualPerMonth: 79, annualTotal: 948 },
  professional: { monthly: 199, annualPerMonth: 159, annualTotal: 1908 },
};

export const ADVISOR_MAILTO = "mailto:solutions@tendstrat.com?subject=TWIN%20plan%20enquiry";

export function canAccess(user, feature) {
  const need = FEATURE_MIN_PLAN[feature];
  if (!need || user?.role === "admin") return true;
  return RANK[user?.plan_info?.effective_plan || "none"] >= RANK[need];
}

export const fmtUsd = (n) => `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;
